import getHelper from '../../../services/getHelper';

class QuizSessionQuestionsHelper extends getHelper('/quiz-session-question/:id') {
  /**
   * @desc Update quiz session question with an array of answers
   * @return {RequestExecute}
   * @example
   * const quizSessionQuestionId = 123;
   * const answers = [1, 2]
   * const response = await myClient.helpers.assessment.quizSessionQuestions.updateAnswers(quizSessionQuestionId, answers)
   */
  updateAnswers(quizSessionQuestionId: number, mcqAnswersIds: number[]) {
    const request = this.update(quizSessionQuestionId, { mcqAnswersIds }, false);

    request.url += `/answers`;

    return request.execute();
  }
}

export default QuizSessionQuestionsHelper;
